// extracted by mini-css-extract-plugin
export default {"grid":"HowItWorksAlternate_grid__VOYBF","mobile_grid":"HowItWorksAlternate_mobile_grid__OpI+p","rtl":"HowItWorksAlternate_rtl__mVstC"};